/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'caret': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" stroke-linecap="round" stroke-width="3" _stroke="currentColor" d="M0 12l8-8M8 4l8 8"/>'
  }
})
